import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md animate-fade-up rounded-3xl border border-stone-200 bg-white p-8 shadow-sm">
        <Link to="/" className="inline-block">
          <p className="font-heading text-3xl font-extrabold tracking-tight text-primary">Avinya <span className="font-semibold text-stone-800">Bookings</span></p>
          <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.32em] text-amber-600">Book · Relax · Celebrate</p>
        </Link>

        {sent ? (
          <div className="mt-8 text-center" data-testid="forgot-sent">
            <CheckCircle size={56} weight="fill" className="mx-auto text-primary" />
            <h1 className="mt-4 font-heading text-2xl font-semibold text-stone-900">Check your email</h1>
            <p className="mt-2 text-sm text-stone-500">If an account exists for <strong>{email}</strong>, we've sent a password reset link. It expires in 1 hour.</p>
            <Link to="/login"><Button className="mt-6 w-full rounded-xl bg-primary py-6 text-base hover:bg-green-900">Back to Login</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="mt-6 font-heading text-2xl font-semibold text-stone-900">Forgot password?</h1>
            <p className="text-sm text-stone-500">Enter your account email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="fp-email">Email</Label>
                <div className="relative mt-1">
                  <EnvelopeSimple size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
                  <Input id="fp-email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl pl-10" placeholder="you@example.com" />
                </div>
              </div>
              {error && <p data-testid="forgot-error" className="text-sm text-destructive">{error}</p>}
              <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full rounded-xl bg-primary py-6 text-base hover:bg-green-900">{loading ? "Sending…" : "Send reset link"}</Button>
            </form>
            <p className="mt-6 text-center text-sm text-stone-500">Remembered it? <Link to="/login" className="font-semibold text-primary hover:underline">Back to Login</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
